var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n  button {\n    margin-top: 10px;\n  }\n  .a-field {\n    @media (max-width: 768px) {\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  }\n'], ['\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n  button {\n    margin-top: 10px;\n  }\n  .a-field {\n    @media (max-width: 768px) {\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import InputText from '../InputText';
import Form, { FieldContainer } from '../Form';
import Field from '../Form/Field';
import { Row, Col } from 'react-flexa';
import Button from '../Button';
var Wrapper = styled.div(_templateObject);

var LeadformGroup = function LeadformGroup(props) {
  var endpoint = props.endpoint || 'https://postoffice.oldmutualstaffcover.co.za/postal-api/hotlead';
  var track = props.track,
      packageId = props.packageId;

  var _useState = useState(),
      firstname = _useState[0],
      setFirstname = _useState[1];

  var _useState2 = useState(),
      lastname = _useState2[0],
      setLastname = _useState2[1];

  var _useState3 = useState(false),
      isValid = _useState3[0],
      setValid = _useState3[1];

  var _useState4 = useState(),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = useState(),
      phonenumber = _useState5[0],
      setPhonenumber = _useState5[1];

  var _useState6 = useState('Leave your details'),
      buttonText = _useState6[0],
      setButtonText = _useState6[1];

  useEffect(function () {
    if (validate_str(firstname, 3) && validate_str(lastname, 3) && validate_str(email, 5) && validate_str(phonenumber, 10)) {
      setValid(true);
    } else {
      setValid(false);
    }
  });

  var submit = function submit() {
    var date = new Date().toJSON();
    var data = {
      senderReference: 'Website-Callback',
      fromNumber: phonenumber,
      emailAddress: email,
      campaign: 'minifix-Leadform',
      replyTime: date,
      firstName: firstname,
      lastName: lastname,
      packageId: packageId | 'sim-family'
    };
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        setButtonText('Sent!');

        if (track) {
          track();
        }
      }
    };

    xhr.open('POST', endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  };

  var validate_str = function validate_str(str, size) {
    if (str && str.length >= size) {
      return true;
    }

    if (str && str.length < size) {
      return false;
    }

    return null;
  };

  return React.createElement(Wrapper, null, React.createElement(Form, {
    noValidate: !isValid
  }, React.createElement(Row, null, React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    minLength: '3',
    onChange: function onChange(e) {
      return setFirstname(e.target.value);
    },
    validates: validate_str(firstname, 3),
    label: 'First Name'
  }))), React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    minLength: '3',
    onChange: function onChange(e) {
      return setLastname(e.target.value);
    },
    validates: validate_str(lastname, 3),
    label: 'Last Name'
  })))), React.createElement(Row, null, React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    type: 'email',
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    validates: validate_str(email, 5),
    label: 'Email address'
  }))), React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    type: 'number',
    min: '1',
    max: '9999999999',
    onChange: function onChange(e) {
      return setPhonenumber(e.target.value);
    },
    validates: validate_str(phonenumber, 10),
    label: 'Phone number'
  })))), React.createElement(Button, {
    disabled: !isValid,
    size: 'medium',
    colour: 'primary',
    onClick: function onClick() {
      return submit();
    }
  }, buttonText)));
};

export default LeadformGroup;